import { UserContext } from "providers/UserProvider"
import { useContext } from "react"
import { NavLink, useLocation, useNavigate } from "react-router-dom"
import styled from "styled-components"

import { AppLogo } from "components/ui/shared/AppLogo";
import { SearchBar } from "../inputs/SearchBar";
import { useErrors } from "providers/ErrorsProvider"
import { MaterialIcon } from "./MaterialIcon"

export const Navbar = () => {

    const {clearErrors} = useErrors();
    const { user, unauthenticateUser } = useContext(UserContext);
    const navigate = useNavigate();

    const location = useLocation();
    const isToolsActive = location.pathname.startsWith("/tools");

    return (
        <StyledNav>
            <AppLogo size='sm' align='left'/>
            <SearchBar placeholder='Søk...'/>
            <div className="navOptionsContainer">
                <StyledNavLink onClick={clearErrors} to="/dashboard" className={({ isActive }) => isActive ? "active" : ""}>
                    <MaterialIcon name='dashboard' weight={300}/> Dashboard
                </StyledNavLink>
                <StyledNavLink onClick={clearErrors} to="/projects" className={({ isActive }) => isActive ? "active" : ""}>
                    <MaterialIcon name='folder_open' weight={300}/> Prosjekter
                </StyledNavLink>
                <StyledNavLink onClick={clearErrors} to="/tasks" className={({ isActive }) => isActive ? "active" : ""}>
                    <MaterialIcon name='ballot' weight={300}/> Oppgaver
                </StyledNavLink>
                
                <StyledNavLink onClick={clearErrors} to="/tools" className={({ isActive }) => isActive ? "active" : ""}>
                    <MaterialIcon name='design_services' weight={300}/> Verktøy
                </StyledNavLink>
                    {
                        isToolsActive &&
                        <div className="toolsSubmenu">
                            <StyledSubmenuLink onClick={clearErrors} to="tools/clothoide" className={({ isActive }) => isActive ? "active" : ""}>Klotoideparameter</StyledSubmenuLink>
                            <StyledSubmenuLink onClick={clearErrors} to="tools/vertical" className={({ isActive }) => isActive ? "active" : ""}>Vertikalkurvatur</StyledSubmenuLink>
                            <StyledSubmenuLink onClick={clearErrors} to="tools/acceleration" className={({ isActive }) => isActive ? "active" : ""}>Akselerasjonsfelt</StyledSubmenuLink>
                            <StyledSubmenuLink onClick={clearErrors} to="tools/retardation" className={({ isActive }) => isActive ? "active" : ""}>Retardasjonsfelt</StyledSubmenuLink>
                            <StyledSubmenuLink onClick={clearErrors} to="tools/overtaking" className={({ isActive }) => isActive ? "active" : ""}>Forbikjøring</StyledSubmenuLink>
                            <StyledSubmenuLink onClick={clearErrors} to="tools/superelevation" className={({ isActive }) => isActive ? "active" : ""}>Overhøyde og tverrfall</StyledSubmenuLink>
                            <StyledSubmenuLink onClick={clearErrors} to="tools/widening" className={({ isActive }) => isActive ? "active" : ""}>Breddeutvidelse</StyledSubmenuLink>
                            <StyledSubmenuLink onClick={clearErrors} to="tools/resslope" className={({ isActive }) => isActive ? "active" : ""}>Resulterende fall</StyledSubmenuLink>
                        </div>
                    }

                    {
                        isToolsActive &&
                        <div className="toolsSubmenu">
                            <StyledSubmenuLink onClick={clearErrors} to="tools/leftturn" className={({ isActive }) => isActive ? "active" : ""}>Venstresvingsfelt</StyledSubmenuLink>
                            <StyledSubmenuLink onClick={clearErrors} to="tools/aadt" className={({ isActive }) => isActive ? "active" : ""}>Timetrafikk fra ÅDT</StyledSubmenuLink>
                            <StyledSubmenuLink onClick={clearErrors} to="tools/forces" className={({ isActive }) => isActive ? "active" : ""}>Fysiske krefter</StyledSubmenuLink>
                            <StyledSubmenuLink onClick={clearErrors} to="tools/signal" className={({ isActive }) => isActive ? "active" : ""}>Skyttesignalanlegg</StyledSubmenuLink>
                        </div>
                    }
                <StyledNavLink onClick={clearErrors} to="/notes" className={({ isActive }) => isActive ? "active" : ""}>
                    <MaterialIcon name='book_5' weight={300}/> Notater
                </StyledNavLink>
                <StyledNavLink onClick={clearErrors} to="/repositories" className={({ isActive }) => isActive ? "active" : ""}>
                    <MaterialIcon name='deployed_code' weight={300}/> Versjonslagring
                </StyledNavLink>
            </div>
            <div className="navUserContainer">
                <div className="navUserIcon">
                    {user.userFullName[0]}
                </div>
                <div className="navUserName">
                    {user.userFullName}
                </div>
                <div
                    className="navUserLogout"
                    onClick={() => {
                        unauthenticateUser();
                        navigate("/");
                    }}
                >
                    <MaterialIcon
                        name='logout'
                        weight={300}
                    />
                </div>
                
            </div>
        </StyledNav>
    )
}

const StyledNav = styled.nav`
    flex: 0 0 275px;
    padding-top: ${({theme}) => theme.spacing.xl}; 
    padding-left: ${({theme}) => theme.spacing.lg}; 
    padding-right: ${({theme}) => theme.spacing.md}; 
    padding-bottom: ${({theme}) => theme.spacing.xl}; 
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.xl};
    background: ${({theme}) => theme.colors.neutralTertiaryBackground};

    div.navOptionsContainer
    {
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.sm};
        flex: 1 1 auto;

        div.toolsSubmenu
        {
            margin-left: ${({theme}) => theme.spacing.lg}; 
            padding-left: ${({theme}) => theme.spacing.lg}; 
            border-left: 1px solid ${({theme}) => theme.colors.neutralPrimaryForeground};  
        }
       
    }

    div.navUserContainer
    {
        display: flex;
        align-items: center;
        gap: ${({theme}) => theme.spacing.sm};
        cursor: pointer;

        div.navUserIcon
        {
            flex: 0 0 26px;
            height: 26px;
            width: 26px;
            background: ${({theme}) => theme.colors.neutralPrimaryForeground};
            color: ${({theme}) => theme.colors.neutralPrimaryBackground}; 
            font-weight: 600;
            font-size: ${({theme}) => theme.fontSize.lg};

            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: ${({theme}) => theme.cornerRadius.md};
        }

        div.navUserName
        {
            flex: 1 1 auto;
        }

        div.navUserLogout
        {
            display: flex;
            align-items: center;
            justify-content: center;

            .icon
            {
                color: ${({theme}) => theme.colors.neutralPrimaryForeground}; 
            }
        }
    }
`

const StyledNavLink = styled(NavLink)`
    border: 1px solid rgba(0, 0, 0, 0);
    display: block;
    padding: ${({theme}) => theme.spacing.xs} ${({theme}) => theme.spacing.md};
    font-size: ${ ({theme}) => theme.fontSize.md};

    display: flex;
    align-items: center;
    text-decoration: none;
    color: ${ ({theme}) => theme.colors.mutedForeground};
    border-radius: ${({theme}) => theme.cornerRadius.md};
    transition-duration: 220ms;
    position: relative;

    .icon
    {
        margin-right: ${({theme}) => theme.spacing.md}; 
    }

    &.active
    {
        border: 1px solid rgba(${ ({theme}) => theme.colors.neutralPrimaryForegroundRGB}, 0.05);
        background: ${ ({theme}) => theme.colors.neutralPrimaryBorder};
        color: ${ ({theme}) => theme.colors.neutralPrimaryForeground};

    }

    &.active::after
    {
        content: "";
        width: 6px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 1000;
        border-radius: ${({theme}) => theme.cornerRadius.sm};
        right: -15px;
        background: ${ ({theme}) => theme.colors.neutralSecondaryForeground};
    }
`

const StyledSubmenuLink = styled(NavLink)`
    display: block;
    text-decoration: none;
    color: ${ ({theme}) => theme.colors.mutedForeground};
    margin: ${({theme}) => theme.spacing.md} 0;
    font-weight: 400;
    position: relative;
    

    &.active
    {
        font-weight: 600;
        color: ${ ({theme}) => theme.colors.neutralPrimaryForeground};
    }

    &.active::before
    {   
        content: "";
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: ${ ({theme}) => theme.colors.neutralSecondaryForeground};
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        left: -20px;
        position: absolute;
    }
`